<template>
  <div id="result" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==2"> 
      <el-alert
        title="尚未開放查詢!!"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
    <div v-else-if="docRecord!=null && docRecord.status==1">
      <div class="">
        <div class="">
          <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF" >
            <thead>
              <tr>
                <th colspan="4" class="ncut-base-form-title" style="background-color: orange; text-align:left; padding: 0.5em;">錄取結果如下:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">考生姓名</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.name}}</span>
                </td>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">報名編號</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.regNo}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取狀況</td>
                <td colspan="3" style="padding:0.1em;">
                  <span class="badge" style="font-size: 1.5rem"
                        v-bind:style="{'background': statusColor}">{{docRecord.note}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取系科</td>
                <td colspan="3" style="padding:0.1em;">
                  <span class="badge badge-primary" style="font-size:1.5rem">{{docRecord.deptName}}</span>
                </td>
              </tr>
              <tr v-if="1<docRecord.showStatus">
                <td class="ncut-base-form-title" style="font-weight:bold; padding: 0.5em;">錄取通知單</td>
                <td colspan="3" style="padding:0.1em;">
                  <!--<a href="#" @click="printData()"><span class="glyphicon glyphicon-download" style="margin-right: 4px;"></span>列印</a>-->
                  <el-button type="primary" @click="printData(user.dId)">下載列印<i class="el-icon-view"></i></el-button>
                  <!--<a :href="'./WebApi/Apply/GetRegisterPrnV2/'+user.dId" download="錄取通知單.pdf">列印</a>-->
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">最低錄取分數</td>
                <td colspan="3" style="padding:0.5em;">
                  <div style="padding: 0.25em 0;">
                    <span>正取生：<span v-if="0<docRecord.floor1">{{docRecord.floor1| numFilter}}</span><span v-if="0==docRecord.floor1">-</span></span>分
                  </div>
                  <div style="padding: 0.25em 0;">
                    <span>備取生：<span v-if="0<docRecord.floor2">{{docRecord.floor2| numFilter}}</span><span v-if="0==docRecord.floor2">-</span></span>分
                  </div>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">備註</td>
                <td colspan="3" style="padding: 0.5em;">
                  <div style="padding: 0.5em 0 0;" 
                    v-html="docRecord.entName"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==5">
      <el-alert
        title="請先完成網路報名。"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
  </div> 
</template>


<script>
export default {
  name: 'result',
  data () {
    return {
      docRecord: null
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    statusColor () {
      let url = '#d9534f';

      if (null != this.docRecord) {        
        switch(this.docRecord.showStatus) {
          case 1:
            url = '#fed71a';
            break;
          case 2:
          case 3:
            url = '#5cb85c';
            break;
        }  
      }
      return url
    }
  },
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2)
      return parseFloat(realVal)
    }
  },
  methods: {
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    showErrorMsg(vm, msg) {
      vm.$notify.error({
                        title: vm.$t('message.Error_txt'),
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        offset: 150
                      });
    },
    printData(dId) {
      let url = './WebApi/Apply/GetRegisterPrnV2/'.concat(dId);
      let params = new URLSearchParams();
      params.append('cdn', this.cdnSelect);

      this.$http.get(url, {    
                  responseType: 'blob',
                  params: params
                }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target','_blank');
                  document.body.appendChild(link);
                  link.click();
                });
    }    
  },
  created () { 
    console.log('======created ResultView=====') 
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetDisResult/'.concat(this.user.dId))
        .then(function(response) {
          if (response.data != null) {
            vm.docRecord = response.data
          } else {
            vm.showErrorMsg(vm, '<strong>對不起,讀取<i style="background:yellow;">分發結果</i>查詢失敗:'+error+'</strong>');
          }
        })
        .catch(function (error) {
          vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ResultView.vue